import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class CashDocumentItem {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsOptional()
  @IsString()
  documentNumber!: string | null;
  @Expose()
  @IsOptional()
  @IsNumber()
  paymentAmount!: null | number;
  @Expose()
  @IsNumber()
  itemAmount!: number;
}
